export enum NumberOfBathrooms {
  One = 'one',
  OneFullAndOneHalf = 'oneFullAndOneHalf',
  Two = 'two',
  TwoFullAndOneHalf = 'twoFullAndOneHalf',
  Three = 'three',
  ThreeFullAndOneHalf = 'threeFullAndOneHalf',
  Four = 'four',
  FourFullAndOneHalf = 'fourFullAndOneHalf',
  Five = 'five',
  FiveFullAndOneHalf = 'fiveFullAndOneHalf',
  Six = 'six',
  SixFullAndOneHalf = 'sixFullAndOneHalf',
}
